import { render, staticRenderFns } from "./CreateCity.vue?vue&type=template&id=ec6a197e&"
import script from "./CreateCity.vue?vue&type=script&lang=js&"
export * from "./CreateCity.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports